import "./hero";
import "./cta";
import "./job-form";
import "./testimonials";
import "./map";
import "./job-header";
import "./job-description";
import "./values";
import "./image-slider";
import "./team";
import "./numbers";
import "./article-content";
import "./accordion";
import "./usp";
import "./contact-form";
import "./intro";
import "./tabs";
import "./image-text";
import "./services";
import "./logos";
import "./social";
import "./hero-small";
import "./filters";
import "./video";
